/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/126-spinner4': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3 8c0-.19.011-.378.032-.563l-2.89-.939A8.085 8.085 0 00.001 8c0 2.3.971 4.374 2.526 5.833l1.786-2.458A4.982 4.982 0 013.001 8zm10 0a4.978 4.978 0 01-1.312 3.375l1.786 2.458A7.975 7.975 0 0016 8c0-.513-.049-1.015-.141-1.502l-2.89.939c.021.185.032.373.032.563zM9 3.1a5.01 5.01 0 013.351 2.435l2.89-.939A8.01 8.01 0 009 .062V3.1zM3.649 5.535A5.007 5.007 0 017 3.1V.062A8.005 8.005 0 00.759 4.596l2.89.939zm6.422 7.017C9.44 12.84 8.739 13 8 13s-1.44-.16-2.071-.448L4.143 15.01C5.287 15.641 6.601 16 8 16s2.713-.359 3.857-.99l-1.786-2.458z"/>'
  }
})
